module.exports = __webpack_public_path__ + "media/images/wfc/venue-6-e26f92dccadc690809b548a2b31fa067.jpg";